"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePendingMealPlan = exports.setMealPlanSchedule = exports.editMealPlan = exports.createMealPlan = exports.uncookUserMeal = exports.cookUserMeal = exports.uncookMeal = exports.cookMeal = void 0;
function cookMeal(client, opts) {
    return client.post('cook_meal', { id: opts.id });
}
exports.cookMeal = cookMeal;
function uncookMeal(client, opts) {
    return client.post('uncook_meal', { id: opts.id });
}
exports.uncookMeal = uncookMeal;
function cookUserMeal(client, opts) {
    return client.post('cook_user_meal', { id: opts.id });
}
exports.cookUserMeal = cookUserMeal;
function uncookUserMeal(client, opts) {
    return client.post('uncook_user_meal', { id: opts.id });
}
exports.uncookUserMeal = uncookUserMeal;
function createMealPlan(client, opts) {
    return client.post('create_meal_plan', {
        recipe_variant_ids: opts.recipeVariantIds,
        data: opts.data,
        builder: opts.builder,
        user_recipe_uids: opts.userRecipeUids
    });
}
exports.createMealPlan = createMealPlan;
function editMealPlan(client, opts) {
    return client.post('edit_meal_plan', {
        original_meal_plan_id: opts.originalMealPlanId,
        recipe_variant_ids: opts.recipeVariantIds,
        user_recipe_uids: opts.userRecipeUids
    });
}
exports.editMealPlan = editMealPlan;
function setMealPlanSchedule(client, opts) {
    return client.post('set_meal_plan_schedule', {
        meal_plan_id: opts.mealPlanId,
        schedule: opts.schedule
    });
}
exports.setMealPlanSchedule = setMealPlanSchedule;
function updatePendingMealPlan(client, opts) {
    return client.post('update_pending_meal_plan', {
        pending_meal_plan: opts.pendingMealPlan
    });
}
exports.updatePendingMealPlan = updatePendingMealPlan;
